import { enumChecker } from './enums.js';

const CreditRoleEnum = {
  ARTIST: "ARTIST",
  PRODUCER: "PRODUCER",
  SONGWRITER: "SONGWRITER",
  CURATOR: "CURATOR",
  REMIXER: "REMIXER",
  VISUAL_ARTIST: "VISUAL_ARTIST",
  OTHER: "OTHER"
};
const isCreditRole = enumChecker(CreditRoleEnum);

export { CreditRoleEnum, isCreditRole };
